"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookContract = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var loan_1 = require("../../model/loan");
var service_1 = require("../../../library/base/service");
var LookContract = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(LookContract, _super);
    function LookContract() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '查看项目接口';
        _this.code = '101077';
        _this.desc = '查看项目接口';
        _this.requestParams = new loan_1.LookContractRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return LookContract;
}(service_1.BaseService));
exports.LookContract = LookContract;
//# sourceMappingURL=lookContract.js.map